import createPersistedState from 'vuex-persistedstate'

const paths = [
  'store.frontendId',
  'store.frontendCid',
  'store.currency',
  'store.sg18pid',
  'store.hasCheckedSubdomain',
  'store.shippingCountry',
  'store.store',
  'store.email',
  'store.country',
  'promo.promoDismissed',
  'cart.runcode',
  'cart.formKey',
  'cart.itemCount',
  'promo.activePromos',
  'page.cookieStatus',
  'page.hideHiringBanner',
  'translations.reviewerId',
  'protect.token',
  'protect.pk',
  'checkout.showSignup'
]

export default ({ store }) => {
  createPersistedState({
    key: 'sgps',
    paths
  })(store)
}
